<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/102KNlH/tc-custom/9781497671034.jpg?1734044662008" alt="This image is the cover for the book Problem of the Evil Editor, The Charles Dodgson and Arthur Conan Doyle Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Problem of the Evil Editor, The Charles Dodgson and Arthur Conan Doyle Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>A vicious newspaperman is murdered, and every scribe in the office is a suspect</b><br/><br/> It is winter in London, and the coal is running short. The chill on Fleet Street is so severe that the men who run the presses for <i>Youth’s Companion </i>are too cold to work. Despite the freeze, their editor—the vile Mr. Bassett—will not spare a shilling for coal. He is behind on paying his employees, has been accused of stealing his writers’ ideas, and refuses to hire any up-and-coming literary talent, be it Oscar Wilde or Arthur Conan Doyle. It is no surprise when the editor is found murdered. The question is, which of his enemies got to him first?<br/><br/> Doyle enlists Charles Dodgson—better known as Lewis Carroll—to look into the murder. When the police try to pin the killing on the slighted Mr. Wilde, it is up to Doyle and Dodgson to clear Wilde’s name and find the true killer of the cruelest man on Fleet Street.<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Roberta Rogow
      </h2>
      
      <p class="authorDescription body article">Roberta Rogow (b. 1942) is an author of speculative fiction. A professional children&rsquo;s librarian, she began writing fan fiction in 1973 after a love of <I>Star Trek</I> lured her to her first science fiction convention. After several years publishing stories in fanzines, she founded <a><I>Grip</I></a>, a multimedia zine focusing on <I>Star Trek</I> and other science fiction, in 1978. After retiring the zine in 1996, Rogow published her first novel, <I>The Problem of the Missing Miss</I> (1998), which began the four-volume Charles Dodgson and Arthur Conan Doyle Mysteries.<BR /><BR /> Rogow&rsquo;s most recent novel is <I>Murders in Manatas</I> (2013). She is also a musician who has been playing sci-fi-inspired folk music since the 1970s.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?306bd1a6